import React from "react";

export default function IconFlagPl() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="640" height="400" viewBox="0 0 8 5">
      <rect width="8" height="5" fill="#dc143c" />
      <rect width="8" height="2.5" fill="#fff" />
    </svg>
  );
}
